module.exports = __webpack_public_path__ + "friend12.png?308036007c52759b34a3819fbea024e8";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend12.png
// module id = 485
// module chunks = 0